/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataRecommendCodeBindPageItemVo } from './PageDataRecommendCodeBindPageItemVo';
import {
    PageDataRecommendCodeBindPageItemVoFromJSON,
    PageDataRecommendCodeBindPageItemVoFromJSONTyped,
    PageDataRecommendCodeBindPageItemVoToJSON,
    PageDataRecommendCodeBindPageItemVoToJSONTyped,
} from './PageDataRecommendCodeBindPageItemVo';

/**
 * 
 * @export
 * @interface ResponsePageDataRecommendCodeBindPageItemVo
 */
export interface ResponsePageDataRecommendCodeBindPageItemVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataRecommendCodeBindPageItemVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataRecommendCodeBindPageItemVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataRecommendCodeBindPageItemVo}
     * @memberof ResponsePageDataRecommendCodeBindPageItemVo
     */
    data?: PageDataRecommendCodeBindPageItemVo;
}

/**
 * Check if a given object implements the ResponsePageDataRecommendCodeBindPageItemVo interface.
 */
export function instanceOfResponsePageDataRecommendCodeBindPageItemVo(value: object): value is ResponsePageDataRecommendCodeBindPageItemVo {
    return true;
}

export function ResponsePageDataRecommendCodeBindPageItemVoFromJSON(json: any): ResponsePageDataRecommendCodeBindPageItemVo {
    return ResponsePageDataRecommendCodeBindPageItemVoFromJSONTyped(json, false);
}

export function ResponsePageDataRecommendCodeBindPageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataRecommendCodeBindPageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataRecommendCodeBindPageItemVoFromJSON(json['data']),
    };
}

export function ResponsePageDataRecommendCodeBindPageItemVoToJSON(json: any): ResponsePageDataRecommendCodeBindPageItemVo {
    return ResponsePageDataRecommendCodeBindPageItemVoToJSONTyped(json, false);
}

export function ResponsePageDataRecommendCodeBindPageItemVoToJSONTyped(value?: ResponsePageDataRecommendCodeBindPageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataRecommendCodeBindPageItemVoToJSON(value['data']),
    };
}

